module.exports = __webpack_public_path__ + "img/box6-08.aef1cbbb.png";